import { supabase } from './supabase';

interface ConfigOption {
  key: string;
  value: string;
  description?: string;
}

// Nome da loja padrão usada para o link de afiliado
const AMAZON_STORE_NAME = 'Amazon';

// Link de afiliado padrão da Amazon (fallback)
export const DEFAULT_AMAZON_AFFILIATE_URL = 'https://amzn.to/4jcXJhu';

/**
 * Serviço para gerenciar configurações globais da aplicação
 */
const configService = {
  /**
   * Obtém o URL de afiliado padrão da Amazon
   * Primeiro procura por uma loja chamada "Amazon" e usa o URL dela
   * Se não encontrar, usa o valor padrão
   */
  async getAmazonAffiliateUrl(): Promise<string> {
    try {
      // Buscar a loja Amazon no banco de dados
      const { data, error } = await supabase
        .from('stores')
        .select('*')
        .ilike('name', AMAZON_STORE_NAME)
        .limit(1);
      
      if (error) {
        console.error('Erro ao buscar link de afiliado da Amazon:', error);
        return DEFAULT_AMAZON_AFFILIATE_URL;
      }
      
      // Se encontrou a loja Amazon, usar o URL dela
      if (data && data.length > 0) {
        const amazonStore = data[0];
        const baseUrl = amazonStore.url || 'https://www.amazon.com.br';
        const affiliateCode = amazonStore.affiliate_code || '';
        
        // Se tiver código de afiliado, adicionar ao URL
        if (affiliateCode) {
          // Verificar se o URL já tem parâmetros
          const separator = baseUrl.includes('?') ? '&' : '?';
          return `${baseUrl}${separator}tag=${affiliateCode}`;
        }
        
        return baseUrl;
      }
      
      // Se não encontrou a loja Amazon, usar o URL padrão
      return DEFAULT_AMAZON_AFFILIATE_URL;
    } catch (error) {
      console.error('Erro ao buscar link de afiliado da Amazon:', error);
      return DEFAULT_AMAZON_AFFILIATE_URL;
    }
  },
};

export default configService; 